export default __webpack_public_path__ + "static/media/navigate-expert.d399e5c9.png";